import {AppLayout} from "src/features/client";
import {CategoriesWidget, PartnersWidget, ProductsWidget} from "src/widgets";
import {Box} from "@mantine/core";

export function CategoryPage() {
    return (
        <AppLayout>

            <Box mt={50} className="container">
                <ProductsWidget page="products"/>
                <PartnersWidget/>
            </Box>
            <CategoriesWidget/>
        </AppLayout >
    );
}
